<div class="single-ticket">
    <!--style="margin-top:20px;" IT CAN BE APPLIED THIS WAY ALWAYS SO ACCORDING TO CASE YOU CAN ADD THE CLASS .margin-top-20-->
    <div class="single-ticket__content">
        <div class="border-line" [ngClass]="{ renew: ticket.renewable }"></div>
        <div class="single-ticket__top-content">
            <div class="single-ticket-left-content">
                <div
                    class="single-ticket-left-content__items"
                    [ngClass]="{ 'transit-message': ticket.trip_messages?.length > 0 }">
                    <span class="title">
                        {{ 'TICKET_SUMMARY_V2_AREA' | translate }}
                    </span>
                    <span class="description">
                        {{ getZones() }}
                        <a
                            class="inline-secondary-description item-link link--emphasized link--action"
                            *ngIf="env.TICKET_HAS_ZONE_MODAL"
                            (click)="showZoneModal()">
                            {{ 'CHOOSE_STOPS_CONSULT_MAP' | translate }}
                        </a>
                        <ridango-trip-message
                            *ngIf="ticket.trip_messages?.length > 0"
                            [messages]="ticket.trip_messages"
                            [locale]="locale"></ridango-trip-message>
                    </span>
                </div>

                <div class="single-ticket-left-content__items">
                    <span class="title">{{ 'TICKET_SUMMARY_V2_VALIDITY' | translate }}</span>
                    <!-- units smaller equal than 1 check in case of web VL period tickets which are validated -->

                    <span
                        class="description"
                        *ngIf="
                            ticket.starting &&
                            ((!ticket.units && !ticket.initial_units) ||
                                (ticket.units <= 1 && ticket.initial_units <= 1))
                        ">
                        <ng-container *ngIf="validityFormatOptions">
                            <span *ngIf="hasFixedStartEndDates">{{ ticketValidityRangeAsString }}</span>
                            <span
                                *ngIf="
                                    !hasFixedStartEndDates &&
                                    ticketValidityRange &&
                                    showValidityAsRange &&
                                    useIntlPeriodTicketValidityDisplay
                                ">
                                {{ ticketValidityRange | dateTimeRange: validityFormatOptions }}
                            </span>
                            <span
                                *ngIf="
                                    !hasFixedStartEndDates &&
                                    ticketValidityRange &&
                                    showValidityAsRange &&
                                    !useIntlPeriodTicketValidityDisplay
                                ">
                                {{ ticketValidityRange | ridangoDateTime: ridangoDateTimeValidityOptions }}
                            </span>
                            <span
                                *ngIf="
                                    !hasFixedStartEndDates &&
                                    ticketValidityRange &&
                                    !showValidityAsRange &&
                                    useIntlPeriodTicketValidityDisplay
                                ">
                                {{ ticketValidityRange[1] | dateTime: validityFormatOptions }}
                            </span>
                            <span
                                *ngIf="
                                    !hasFixedStartEndDates &&
                                    ticketValidityRange &&
                                    !showValidityAsRange &&
                                    !useIntlPeriodTicketValidityDisplay
                                ">
                                {{ ticketValidityRange[1] | ridangoDateTime: ridangoDateTimeValidityOptions }}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="!validityFormatOptions">
                            <span *ngIf="showValidityAsRange && ticketValidityRange">
                                {{ ticketValidityRange | ridangoDateTime: ridangoDateTimeValidityOptions }}
                            </span>
                            <span *ngIf="!showValidityAsRange && ticketValidityRange">
                                {{ ticketValidityRange[1] | ridangoDateTime: ridangoDateTimeValidityOptions }}
                            </span>
                        </ng-container>
                    </span>

                    <div *ngIf="!useActiveValidationText">
                        <span
                            class="description"
                            *ngIf="(ticket.units > 1 || ticket.initial_units > 1) && ticketValidityRange">
                            {{ ticketValidityRange | ridangoDateTime: ridangoDateTimeValidityOptions }}
                        </span>

                        <span
                            class="description"
                            *ngIf="
                                ticket.booklet_ending &&
                                ticket.units &&
                                ticket.initial_units &&
                                (ticket.units > 1 || ticket.initial_units > 1) &&
                                !ticketValidityRange
                            ">
                            {{
                                [ticket.starting, ticket.booklet_ending]
                                    | ridangoDateTime: ridangoDateTimeValidityOptions
                            }}
                        </span>

                        <span
                            class="description"
                            *ngIf="
                                ticket.units &&
                                ticket.initial_units &&
                                !ticket.booklet_ending &&
                                (ticket.units > 1 || ticket.initial_units > 1)
                            ">
                            {{ ticket.units | i18nPlural: bookletUnitsMapping | translate: ticket }}
                        </span>
                        <span
                            class="description"
                            *ngIf="!ticket.starting && !(ticket.units > 1 || ticket.initial_units > 1)">
                            <ng-template *ngIf="isActivatedAtPurchase; then showBlock; else notShowBlock"></ng-template>
                            <ng-template #showBlock>
                                {{ 'TICKET_SUMMARY_V2_VALID_FROM_PURCHASE' | translate }}
                            </ng-template>
                            <ng-template #notShowBlock>{{ 'TICKET_SUMMARY_V2_VALIDITY_INFO' | translate }}</ng-template>
                        </span>
                    </div>

                    <div *ngIf="useActiveValidationText">
                        <span class="description" *ngIf="ticket.units > 1 || ticket.initial_units > 1">
                            <span class="description" *ngIf="ticketValidityRange">
                                {{ ticketValidityRange | ridangoDateTime: ridangoDateTimeValidityOptions }}
                            </span>

                            <span
                                class="description"
                                *ngIf="!ticketValidityRange && ticket.booklet_ending && ticket.starting">
                                {{
                                    [ticket.starting, ticket.booklet_ending]
                                        | ridangoDateTime: ridangoDateTimeValidityOptions
                                }}
                            </span>

                            {{ ticket.units | i18nPlural: bookletUnitsMapping | translate: ticket }}
                        </span>

                        <span
                            class="description"
                            *ngIf="!ticket.starting && (ticket.units <= 1 || ticket.initial_units <= 1)">
                            <span>{{ 'TICKET_SUMMARY_V2_VALIDITY_INFO' | translate }}</span>
                        </span>
                    </div>
                </div>
            </div>

            <div class="single-ticket-right-content">
                <div class="single-ticket-left-content__items full-width">
                    <span class="title">{{ 'TICKET_SUMMARY_V2_PRICE' | translate }}</span>
                    <span class="description" *ngIf="!ticket.price && ticket.product_price_object?.price">
                        {{ ticket.product_price_object.price | moneyFormat }}
                        {{ appStartupService.getCurrency() | translate }}
                    </span>
                    <span
                        class="description"
                        *ngIf="!ticket.price && !ticket.product_price_object && ticket.product?.price">
                        {{ ticket.product.price | moneyFormat: (jointTicketRangeTotalDays$ | async) }}
                        {{ appStartupService.getCurrency() | translate }}
                    </span>
                    <span class="description" *ngIf="ticket.price">
                        {{ ticket.price | moneyFormat }} {{ appStartupService.getCurrency() | translate }}
                    </span>
                    <span
                        class="description"
                        *ngIf="!ticket.price && !ticket.product_price_object && !ticket.product?.price">
                        -
                    </span>
                    <span
                        class="description line-through opacity-60"
                        *ngIf="ticket.base_price && ticket.base_price > ticket.price">
                        {{ ticket.base_price | moneyFormat }} {{ appStartupService.getCurrency() | translate }}
                    </span>
                </div>
            </div>
        </div>

        <div class="single-ticket-left-content remove-padding-margin-border">
            <div class="single-ticket-left-content__items">
                <span class="title">
                    <span>{{ 'TICKET_SUMMARY_V2_TICKET_TYPE' | translate }}</span>
                    <span *ngIf="ticket.amount">&middot; {{ 'TICKET_AMOUNT' | translate }}</span>
                </span>
                <span class="secondary-description">
                    <span>
                        {{
                            ticket.product ?? ticket.product_object ?? ticket
                                | translateObjectField: 'name' : locale : 'product_name'
                        }}
                    </span>
                    <span *ngIf="ticket.amount">&middot; {{ ticket.amount }}</span>
                </span>
            </div>

            <div class="single-ticket-left-content__items">
                <span class="title">
                    <span class="inline-title">{{ getMediumType() | translate }}</span>
                </span>
                <!-- <span class="inline-secondary-description">Person with disabilities</span> <span class="dash">-</span>
                <span class="inline-secondary-description">123456789</span> -->
                <span class="inline-secondary-description" *ngIf="ticket.travellerCategory">
                    {{ ticket.travellerCategory | translateObjectField: 'name' : locale }}
                </span>
                <span class="dash" *ngIf="ticket.travellerCategory">-</span>
                <span class="inline-secondary-description" *ngIf="getMedium()">{{ getMedium() }}</span>
                <span
                    class="inline-secondary-description"
                    *ngIf="
                        !ticket.travellerCategory &&
                        !getMedium() &&
                        !isVoucher() &&
                        !ticket.travelCardsIds &&
                        !ticket.docNums
                    ">
                    {{ 'CHOOSE_MEDIUM_BELOW' | translate }}
                </span>
                <span class="inline-secondary-description" *ngIf="isVoucher()">{{ 'ON_VOUCHER' | translate }}</span>

                <a
                    class="pn-dark:!text-black inline-secondary-description link--no-line traveler-cards"
                    *ngIf="ticket && ticket.travelCardsIds && !getMedium()"
                    (click)="toggleOpenTickets()"
                    (keydown.enter)="toggleOpenTickets()"
                    (keydown.space)="toggleOpenTickets()">
                    <span>{{ ticket?.travelCardsIds?.length }}</span>
                    <span>{{ 'CARDS_COUNT' | translate }}</span>
                    <span class="icon icon-arrow-dropdown" [ngClass]="{ 'open-table': openTickets }"></span>
                </a>

                <a
                    class="pn-dark:!text-black inline-secondary-description link--no-line traveler-cards"
                    *ngIf="ticket && ticket.docNums"
                    (click)="toggleOpenTickets()"
                    (keydown.enter)="toggleOpenTickets()"
                    (keydown.space)="toggleOpenTickets()">
                    <span>{{ ticket?.docNums?.length }}</span>
                    <span>{{ 'CARDS_COUNT' | translate }}</span>
                    <span class="icon icon-arrow-dropdown" [ngClass]="{ 'open-table': openTickets }"></span>
                </a>

                <!-- for ticket selection mobile view -->
                <div
                    class="table-margin-20 table-mobile-purchase table"
                    *ngIf="ticket && ticket.travelCardsIds && cardsNotEmpty"
                    [ngClass]="{ 'open-table': openTickets }"
                    [ngClass]="{ 'open-table': openTickets }">
                    <ridango-table-row *ngFor="let cardId of ticket.travelCardsIds; let even = even" [isEven]="even">
                        <div class="col-item w4">
                            <span class="mobile-display">{{ 'CARD_NUMBER' | translate }}</span>
                            {{ cards[cardId].card_nr }}
                        </div>

                        <div class="col-item w5-purchase-case">
                            <span class="mobile-display">{{ 'CARD_NAME' | translate }}</span>
                            {{ cards[cardId].name }}
                        </div>

                        <div class="col-item w3 remove">
                            <a
                                class="link--no-line link--remove link"
                                [ngClass]="{ 'pn-dark:!text-white': even, 'pn-dark:!text-black': !even }"
                                (click)="removeCard(cardId)"
                                (keydown.enter)="removeCard(cardId)"
                                (keydown.space)="removeCard(cardId)">
                                {{ 'REMOVE_CARD' | translate }}
                            </a>
                        </div>
                    </ridango-table-row>
                </div>

                <!-- for shopping cart mobile view -->
                <div
                    class="table-margin-20 table-mobile-purchase table"
                    *ngIf="ticket && ticket.docNums?.length"
                    [ngClass]="{ 'open-table': openTickets }">
                    <ridango-table-row *ngFor="let docNum of ticket.docNums; let even = even" [isEven]="even">
                        <div class="col-item w4">
                            <span class="mobile-display">{{ 'CARD_NUMBER' | translate }}</span>
                            {{ ticketsByDocNums[docNum].visual_card_id }}
                        </div>

                        <div class="col-item w5-purchase-case">
                            <span class="mobile-display">{{ 'CARD_NAME' | translate }}</span>
                            {{ ticketsByDocNums[docNum].related_card_name }}
                        </div>

                        <div class="col-item w3 remove">
                            <a
                                class="link--no-line link--remove"
                                *ngIf="canDeleteFromCart"
                                (click)="removeCard(docNum)"
                                (keydown.enter)="removeCard(docNum)"
                                (keydown.space)="removeCard(docNum)">
                                {{ 'REMOVE_CARD' | translate }}
                            </a>
                        </div>
                    </ridango-table-row>
                </div>
            </div>
        </div>

        <div class="single-ticket-right-content remove-padding-margin-border">
            <ridango-ticket-actions-dropdown
                *ngIf="!useInputActions && ticket.actions && ticket.actions.length !== 0"
                [actions]="ticket.actions"
                [type]="'REGULAR'"
                [locale]="locale"
                [showDropdownAlways]="showActionDropdownAlways"
                (actionClicked)="actionClicked($event, ticket)"></ridango-ticket-actions-dropdown>
            <ridango-ticket-actions-dropdown
                #ticketActionsEl
                *ngIf="useInputActions && actions && actions.length !== 0"
                [actions]="actions"
                [type]="'REGULAR'"
                [locale]="locale"
                (actionClicked)="actionClicked($event, ticket)"></ridango-ticket-actions-dropdown>
        </div>
        <!--Email notification in shopping cart -->
        <div class="item-notification table" *ngIf="ticket.notifications">
            <div class="row-items table-content odd" *ngFor="let notification of ticket.notifications?.selected">
                <div class="col-item ticket-type">
                    <div>
                        <span class="arrow"><img src="assets/icon_arrow.png" alt="" /></span>
                        {{ notification.label | translate }}
                    </div>
                </div>
                <div class="col-item ticket-card-email">
                    <span>{{ ticket.email }}</span>
                </div>
            </div>
        </div>
        <!--End-->
        <!--Email notification in active tickets -->
        <!-- <div class="table item-notification" *ngIf="ticket.ticket_info && !ticket.notifications">
            <div class="row-items table-content odd">
                <div class="col-item ticket-type">
                    <div><span class="arrow"><img src="assets/icon_arrow.png" alt=""></span>
                        {{'LOCAL_EMAIL_WHEN_ENDING' | translate}}
                    </div>
                </div>
                <div class="col-item ticket-card-email"><span>{{ticket.ticket_info}}</span>
                </div>
            </div>
        </div> -->
        <!--End-->
    </div>

    <!-- for ticket selection desktop view -->
    <div
        class="table-margin-20 table-desktop-purchase table"
        *ngIf="ticket && ticket.travelCardsIds?.length && cardsNotEmpty"
        [ngClass]="{ 'open-table': openTickets }"
        [ngClass]="{ 'open-table': openTickets }">
        <ridango-table-row *ngFor="let cardId of ticket.travelCardsIds; let even = even" [isEven]="even">
            <div class="col-item w4">
                <span class="icon icon-card"></span>
                {{ cards[cardId].card_nr }}
            </div>

            <div class="col-item w5-purchase-case">
                {{ cards[cardId].name }}
            </div>

            <div class="col-item w3 remove">
                <a
                    class="link--no-line link--remove link"
                    [ngClass]="{ 'pn-dark:!text-white': even, 'pn-dark:!text-black': !even }"
                    (click)="removeCard(cardId)"
                    (keydown.enter)="removeCard(cardId)"
                    (keydown.space)="removeCard(cardId)">
                    {{ 'REMOVE_CARD' | translate }}
                </a>
            </div>
        </ridango-table-row>
    </div>

    <!-- for shopping cart desktop view -->
    <div
        class="table-margin-20 table-desktop-purchase table"
        *ngIf="ticket && ticket.docNums?.length"
        [ngClass]="{ 'open-table': openTickets }">
        <ridango-table-row *ngFor="let docNum of ticket.docNums; let even = even" [isEven]="even">
            <div class="col-item w4">
                <span class="icon icon-card"></span>
                {{ ticketsByDocNums[docNum].visual_card_id }}
            </div>

            <div class="col-item w5-purchase-case">
                {{ ticketsByDocNums[docNum].related_card_name }}
            </div>

            <div class="col-item w3 remove">
                <a
                    class="link--no-line link--remove link"
                    *ngIf="canDeleteFromCart"
                    [ngClass]="{ 'pn-dark:!text-white': even, 'pn-dark:!text-black': !even }"
                    (click)="removeCard(docNum)"
                    (keydown.enter)="removeCard(docNum)"
                    (keydown.space)="removeCard(docNum)">
                    {{ 'REMOVE_CARD' | translate }}
                </a>
            </div>
        </ridango-table-row>
    </div>
</div>
